const state = {
  foundInStatuses: []
}

const getters = {
  getFoundInStatuses: (state) => state.foundInStatuses
}

const mutations = {
  setFoundInStatuses(state, statuses) {
    state.foundInStatuses = statuses || []
  },
  clearFoundInStatuses(state) {
    state.foundInStatuses = []
  }
}

const actions = {
  updateFoundInStatuses({ commit }, statuses)
  {
    commit('setFoundInStatuses', statuses)
  },
  resetFoundInStatuses({ commit }) {
    commit('clearFoundInStatuses')
  }
}

export {
  state,
  getters,
  mutations,
  actions
}
